import { LoadSpinner } from '@calizahq/react-components-v2'
import { BookablePersonType } from '@sales-app/types/BookablePersonType'
import { CommunicationLogs } from '@sales-app/views/Workspace/PersonSummary/CommunicationLogs/CommunicationLogs'
import React from 'react'

import { MemberDetail } from '@/types/User'

export function DetailView({ member }: { member: MemberDetail }) {
  const bookablePerson = member?.id
    ? {
        bookablePersonId: member.id,
        bookablePersonType: BookablePersonType.MEMBER,
      }
    : null

  return (
    <>
      {member.notes && (
        <div className="flex flex-col mb-6 mr-4 w-full">
          <h3 className="mb-4 text-header-md">Notes</h3>
          <div className="rounded  py-2 text-sm leading-140">{member.notes}</div>
        </div>
      )}
      {bookablePerson ? (
        <div className="flex flex-col mb-6 mr-4 w-full">
          <h3 className="mb-4 text-header-md">Activity Feed</h3>
          <CommunicationLogs bookablePerson={bookablePerson} />
        </div>
      ) : (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      )}
    </>
  )
}
